import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Form } from "../../lib";
import { createDoc, fetchDoc, saveDoc } from "../../reducers/docs/actions";
import { navigate } from "../../services";
import { AppState } from "../../store";
import { Constraints, Editing, Fields } from "./types";

const Container = styled.div`
    margin: 0 auto 60px auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
`;

export const EVT_DOC_CREATE = "doc/CREATE";

function mapStateToProps(state: AppState, ownProps?: { doc_id: number }) {
    return {
        //@ts-ignore
        doc: state.docs.get(ownProps!.doc_id),
    };
}
const mapDispatch = { fetchDoc, createDoc, saveDoc };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatch;
type OwnProps = {
    doc_id?: number;
    editing: Editing;
};
type Props = StateProps & DispatchProps & OwnProps;

class DocForm extends React.Component<Props> {
    private order = ["name"];

    private fields: Fields = {
        name: {
            type: "text",
        },
    };

    private constraints: Constraints = {
        name: {
            presence: { message: "nameRequired" },
            length: {
                minimum: 3,
                message: "nameMinChars",
            },
        },
    };

    componentDidMount() {
        const { editing, doc_id } = this.props;
        if (editing === "Edit" && !doc_id) {
            this.props.fetchDoc(doc_id);

            this.order = ["name", "status", "visibility"];
            this.fields.status = {
                type: "select",
                value: "PUBLISHED",
                values: ["DRAFT", "PUBLISHED"],
            };

            this.fields.visibility = {
                type: "select",
                value: "PUBLIC",
                values: ["PUBLIC", "PRIVATE"],
            };
        }
    }

    onSubmit = (values: any) => {
        const { editing, doc_id } = this.props;
        if (editing === "Edit") {
            this.props.saveDoc({
                doc_id,
                data: values,
            });
        } else {
            this.props.createDoc({
                ...values,
                status: "PUBLISHED",
                visibility: "PUBLIC",
                redirect: true,
            });

            const { gtag } = window;
            gtag("event", "doc", {
                event_label: "create",
            });
        }
    };

    onCancel = () => navigate.to("/app/docs");

    render() {
        return (
            <Container>
                <Form
                    id="doc"
                    heading="title"
                    updateProp="doc"
                    doc={this.props.doc}
                    order={this.order}
                    fields={this.fields}
                    constraints={this.constraints}
                    focusOnFirst={true}
                    editing={this.props.editing}
                    onSubmit={this.onSubmit}
                    onAlternate={this.onCancel}
                />
            </Container>
        );
    }
}

export default connect(mapStateToProps, mapDispatch)(DocForm);
